export default __webpack_public_path__ + "static/media/image_graph.a0f58113.png";